export class DeviceDistribution {
    public deviceName: string;
    public appVersion: string;
    public batteryPercentage: number;
    public distributionProgress: number;
    public distributionProgressEarly: number;
    public distributionProgressLate: number;
    public distributionProgressFull: number;

    constructor();
    constructor(json: any);
    constructor(json?: DeviceDistribution) {
        if (json) {
            this.deviceName = json.deviceName;
            this.appVersion = json.appVersion;
            this.batteryPercentage = json.batteryPercentage;
            this.distributionProgress = json.distributionProgress;
            this.distributionProgressEarly = json.distributionProgressEarly;
            this.distributionProgressLate = json.distributionProgressLate;
            this.distributionProgressFull = json.distributionProgress + json.distributionProgressEarly + json.distributionProgressLate;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/device-distribution.ts